/* This file is autogenerated, see readme.md for instructions */
import FolderFullSvgIcon from '@bloomreach/banana-theme/icons/folder-full.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const FolderFullIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <FolderFullSvgIcon />
    </Icon>
  );
});

FolderFullIcon.displayName = 'FolderFullIcon';

export default FolderFullIcon;
